import { Box, Typography } from "@mui/material";
import { useSingleUserControl } from "../../../context/SuperAdmin/SingleUserControlContext";
import { formatFechaWithHour } from "../../../utils/dateFunctions";
import EstadoBadge from "./EstadoBadge";

const DynamoDBView = () => {
  const { dynamoUser } = useSingleUserControl();

  // En caso de que no exista el usuario
  if (!dynamoUser) {
    return (
      <Box pt={2} my={8} textAlign="center">
        <Typography fontSize={16} fontStyle="italic">
          No existe un usuario en DynamoDB con este email.
        </Typography>
      </Box>
    );
  }

  const { id, name, email, isActive, createdAt, updatedAt } = dynamoUser;

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: 2,
        pt: 2,
        fontSize: "14px",
      }}
    >
      {/* ID */}
      <Box>
        <Typography fontWeight="bold">ID</Typography>
        <Typography>{id}</Typography>
      </Box>

      {/* Nombre */}
      <Box>
        <Typography fontWeight="bold">Nombre</Typography>
        <Typography>{name}</Typography>
      </Box>

      {/* Email */}
      <Box>
        <Typography fontWeight="bold">Email</Typography>
        <Typography>{email}</Typography>
      </Box>

      {/* Activo */}
      <Box>
        <Typography fontWeight="bold">Estado</Typography>
        <Typography>
          <EstadoBadge estado={isActive ? "success" : "warning"}>
            {isActive ? "Activo" : "Inactivo"}
          </EstadoBadge>
        </Typography>
      </Box>

      {/* Fecha de creación */}
      <Box>
        <Typography fontWeight="bold">Fecha de creación</Typography>
        <Typography>{formatFechaWithHour(createdAt)}</Typography>
      </Box>

      {/* Última actualización */}
      <Box>
        <Typography fontWeight="bold">Última actualización</Typography>
        <Typography>{formatFechaWithHour(updatedAt)}</Typography>
      </Box>
    </Box>
  );
};

export default DynamoDBView;
